import { useEffect } from 'react';

import { TagManager } from '~/src/common/services/TagManager';
import Tracker from '~/src/common/services/Tracker';
import { type Category } from '~/src/common/typings/category';
import { getCommonProductsEventProperties } from '~/src/common/utils/product';
import { isProduct } from '~/src/typings/products/guards';

export const useCategoryAnalytics = (category: Category | undefined) => {
  useEffect(() => {
    if (!category) return;

    // Catégorie principale
    if (category.parent == null) {
      TagManager.pageView('CategoryPage');
      Tracker.sendEvent('category page viewed', {
        'is page viewed': true,
        'current page name': document.title,
        'current page path': location.pathname,
        'current page type viewed': 'category page',
      });
    }
    // Sous-catégorie
    else {
      TagManager.pageView('SubcategoryPage');
      Tracker.sendEvent('subcategory page viewed', {
        'is page viewed': true,
        'subcategory name': category.title,
        'current page name': document.title,
        'current page path': location.pathname,
        'current page type viewed': 'subcategory page',
        ...getCommonProductsEventProperties(category.items.filter(isProduct)),
      });
    }
  }, [category]);
};
